/**
 * The 3-tier model choices offered wherever BYO-AI picks a model (the
 * Integrations page dropdown, and the default used when a tenant hasn't
 * picked one yet). IDs verified against each provider's own docs - a
 * mistyped free-text model id was exactly the bug this replaces (it 404s
 * with no obvious cause).
 */
export interface ModelOption {
  id: string;
  label: string;
}

export const ANTHROPIC_MODEL_OPTIONS: ModelOption[] = [
  { id: "claude-haiku-4-5", label: "Haiku 4.5 (fastest, most affordable)" },
  { id: "claude-sonnet-5", label: "Sonnet 5 (balanced - recommended)" },
  { id: "claude-opus-5", label: "Opus 5 (most capable)" },
];

export const OPENAI_MODEL_OPTIONS: ModelOption[] = [
  { id: "gpt-5.6-luna", label: "GPT-5.6 Luna (fastest, most affordable)" },
  { id: "gpt-5.6-terra", label: "GPT-5.6 Terra (balanced - recommended)" },
  { id: "gpt-6-astra", label: "GPT-6 Astra (most capable)" },
];

export const DEFAULT_ANTHROPIC_MODEL = ANTHROPIC_MODEL_OPTIONS[1]!.id;
export const DEFAULT_OPENAI_MODEL = OPENAI_MODEL_OPTIONS[1]!.id;

export const modelOptionsForProvider = (provider: string): ModelOption[] =>
  provider === "openai" ? OPENAI_MODEL_OPTIONS : ANTHROPIC_MODEL_OPTIONS;
